import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Col, Row, Typography } from 'antd';
import ButtonGroup from 'antd/es/button/button-group';
import { FolderCard } from 'features/Dashboard/ui/folder-card';
import { useGetCategoryPendingDocumentList } from 'features/document-report/use-cases/get-category-pending';
import { useUserContext } from 'features/users';
import { Fragment, useEffect, useState } from 'react';
import { MonthValue } from 'routes/utils';

import { PendingDocumentsView } from './pending-documents';
import { SubCategoryDocumentView } from './sub-category-documents';
// import Title from 'antd/es/skeleton/Title';

const { Title } = Typography;

export const CategoryDetails = ({
  Category_document,
  setAddCommentsModal,
  setCommentsInfo,
  setDocumentUploadModal,
  // selectedValue,
  searchName,
  year,
  month,
  finishedValue,
  initilaMarkFinished,
}: // selectFilterValue,
any) => {
  const { user } = useUserContext();
  const [showCategoryList, setCategoryList] = useState(true);
  const [showSubCategory, setShowSubCategory] = useState(false);
  const [subCategoryData, setSubCategoryData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(6); // Number of items per page
  // const getTextForValue = (selectedValues: number): string | null => {
  //   const rcArray = selectFilterValue?.data?.rc;
  //   const matchedItem = rcArray?.find(
  //     (item: any) => item.value === selectedValues,
  //   );

  //   return matchedItem ? matchedItem.text : null;
  // };
  const { data: pendingDocumentData, refetch: reFetchPendingDocument } =
    useGetCategoryPendingDocumentList({
      CompanyId: user?.CompanyId,
      DocumentStatusId: 1,
      PageIndex: currentPage,
      RecordPerPage: itemsPerPage,
      Year: year,
      Month: month,
      ClientId: user?.Id,
      // PeriodId: selectedValue || 1,
      Name: searchName,
    } as any);
  const getMonthName = (monthNumber: number): string => {
    if (monthNumber >= 1 && monthNumber <= 12) {
      return MonthValue[monthNumber - 1]; // Adjust for 0-based index
    }

    return 'Invalid Month'; // Fallback for invalid numbers
  };
  const monthNumber = month;
  const showSubCategoryData = (data: any) => {
    setCategoryList(false);
    setShowSubCategory(true);
    setSubCategoryData(data);
  };
  const titleText = `${getMonthName(monthNumber)} ${year}`;
  const activetab = localStorage.getItem('activeTab'); // Fetch the activeTab value
  useEffect(() => {
    if (activetab === '1') {
      // Check if activeTab is '1'
      reFetchPendingDocument(); // Call the function only when activeTab is '1'
      initilaMarkFinished();
    }
  }, [year, month, activetab]); // Dependency on finishedValue

  return (
    <Fragment>
      <Row className='crdsubhed' justify='space-between'>
        <Title level={3}>{titleText}</Title>
        {
          <ButtonGroup
            className='fixed left-0 right-0 bottom-0 bg-white p-3
          sm:relative md:relative lg:relative 2xl:relative xl:relative
          sm:p-0 md:p-0 lg:p-0 2xl:p-0 xl:p-0
          '
          >
            {(!finishedValue?.rc ||
              finishedValue?.rc.length === 0 ||
              finishedValue?.rc[0]?.status === 1) && (
              <Button
                style={{ display: 'flex', alignItems: 'center' }}
                onClick={() => setDocumentUploadModal(true)}
                className='btn btn-primary w-full text-center justify-center !p-2 hover:!text-white'
              >
                <PlusCircleOutlined /> UPLOAD NEW DOCUMENTS
              </Button>
            )}
          </ButtonGroup>
        }
      </Row>

      {showCategoryList && (
        <Typography className='ctgrybx'>
          {Category_document?.length > 0 && <h4>Categories</h4>}
        </Typography>
      )}

      <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
        {showCategoryList &&
        Array.isArray(Category_document) &&
        Category_document?.length
          ? Category_document?.map((item: any, index: number) => (
              <Col
                key={index}
                xxl={6}
                xl={8}
                lg={8}
                md={12}
                sm={24}
                role='button'
                className='self-stretch'
              >
                <FolderCard
                  name={item.categoryName}
                  noOfDocuments={item.noOfDocuments}
                  lastUpdatedDate={item.lastUpdatedDate}
                  onClick={() => showSubCategoryData(item)}
                  isEmpty={item.noOfDocuments === 0}
                />
              </Col>
            ))
          : ''}
      </Row>
      {showSubCategory ? (
        <SubCategoryDocumentView
          subCategoryDocument={subCategoryData}
          setCategoryList={setCategoryList}
          setShowSubCategory={setShowSubCategory}
          setAddCommentsModal={setAddCommentsModal}
          setCommentsInfo={setCommentsInfo}
        />
      ) : (
        ''
      )}
      {showCategoryList &&
        pendingDocumentData &&
        pendingDocumentData?.rc &&
        pendingDocumentData?.rc.length > 0 && (
          <Col span={24} className='border-t-2 border-transparent border-solid'>
            <div className='font-semibold  text-lg mb-2 mt-3'>
              Pending Document
            </div>
            <PendingDocumentsView
              pendingDocument={pendingDocumentData}
              //    reFetchPendingDocument={reFetchPendingDocument}
              setAddCommentsModal={setAddCommentsModal}
              setCommentsInfo={setCommentsInfo}
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
            />
          </Col>
        )}
    </Fragment>
  );
};
